import { expected } from '@aloft/toolkit-shared';
import { createSelector } from '@reduxjs/toolkit';

import { DepreciationSegment } from '../../constants.ts';
import { selectImprovementsById } from './propertyDataSelectors/improvementsSelectors.ts';
import { selectDepreciationSegments } from './selectDepreciationSegments.ts';

export const selectDepreciationSegmentsWithMainDwelling = createSelector(
  [selectDepreciationSegments, selectImprovementsById],
  (segments, improvements) => [
    {
      effectiveAgeField: 'effectiveAge',
      ecoLifeField: 'totalEconomicLife',
      label: 'Main Dwelling',
      enabled: true,
      orderFeature: null,
      defaultEcoLifeField:
        expected(improvements).propertyType === 'manufacturedHome'
          ? 'defaultEcoLifeManufactured'
          : 'defaultEcoLife',
    } as DepreciationSegment,
    ...segments,
  ],
);
